import './_tab-component.scss';

/*
* This function create for tab component and integrated logic for accessibility.
* */

export default function TabComponent() {
    const $tabComponents = document.querySelectorAll('.tab-component');

    if ($tabComponents) {
        $tabComponents.forEach(($tabComponent: Element) => {
            const $tabs = $tabComponent.querySelectorAll('button.show-details');
            const $contents = $tabComponent.querySelectorAll('.content');
            const $select = $tabComponent.querySelector('.select') as any;

            if ($tabs) {
                $tabs.forEach(($tab: Element) => {
                    const tabId = $tab.getAttribute('id');
                    $tab.addEventListener('click', () => {
                        $tabs.forEach(($tab: Element) => {
                            $tab.classList.remove('selected');
                            $tab.setAttribute('aria-selected', 'false');
                            $tab.setAttribute('tabindex', '-1');
                        });

                        $tab.classList.add('selected');
                        $tab.setAttribute('aria-selected', 'true');
                        $tab.setAttribute('tabindex', '0');


                        $contents.forEach(($content: Element) => {
                            if (tabId && $content.id.includes(tabId)) {
                                $content.classList.add('visible');
                                const $carousel = $content.querySelector('.carousel .splide') as HTMLElement;
                                if($carousel) {
                                    window.dispatchEvent(new Event('resize'));
                                }
                            } else {
                                $content.classList.remove('visible');
                            }
                        });
                    });

                    if ($select) {
                        $select.addEventListener('change', () => {
                            $contents.forEach(($content: Element) => {
                                const optionValue = $select.value;
                                const contentId = $content.id;

                                if (contentId === optionValue) {
                                    $content.classList.add('visible');
                                    $content.setAttribute('aria-hidden', 'true');
                                } else {
                                    $content.classList.remove('visible');
                                    $content.setAttribute('aria-hidden', 'false');
                                }
                            });

                            $tabs.forEach(($tab: Element) => {
                                const tabId = $tab.getAttribute('id');
                                if (tabId === $select.value) {
                                    ($tab as HTMLButtonElement).click();
                                }
                            });
                        });
                    }

                    if (tabId && tabId === 'tab-1') {
                        ($tab as HTMLButtonElement).click();
                    }
                });
            }

            let allAttachments = false;
            if($contents){
                $contents.forEach(($content : any) => {
                    allAttachments = !!$content.querySelector('.list-entities');
                })
            }

            if(allAttachments){
                $tabComponent?.classList.add('attachments-filters');
            }

            function handleAccessibility() {
                const $buttons = Array.from($tabComponent.querySelectorAll('button.show-details'));
                let currentTab = 0;

                $buttons.forEach(($btn: any, index: number) => {
                    $btn.addEventListener('keydown', function (event: any) {
                        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
                            if (event.key === 'ArrowLeft') {
                                currentTab = currentTab === 0 ? $buttons.length - 1 : currentTab - 1;
                            } else {
                                currentTab = currentTab === $buttons.length - 1 ? 0 : currentTab + 1;
                            }

                            ($buttons[currentTab] as any).focus();
                        }
                    });

                    $btn.addEventListener('click', function () {
                        currentTab = index;
                    });
                });
            }

            function init() {
                handleAccessibility();
            }

            init();
        });
    }
}
